// libs
import React, { memo } from 'react';
import DomainConfigContext from './context';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

// helpers
import { getDomainConfig } from 'shared/domainConfig/helpers';

interface DomainContextProvider {
  children: React.ReactNode;
}

function Provider({ children }: DomainContextProvider) {
  const domainConfigWithDefaults = getDomainConfig();
  const domain = useRemoteConfig('domain');
  const enableFEMigration = useRemoteConfig('enableFEMigration');

  const config = {
    ...domainConfigWithDefaults,
    ...domain,
    SHOULD_USE_FE_API_V2: enableFEMigration,
  };

  return <DomainConfigContext.Provider value={config}>{children}</DomainConfigContext.Provider>;
}

export default memo(Provider);
